import { combineReducers, createReducer, on } from '@ngrx/store';
import { GenesysCloudConversationToastMessagesSubState as State, initialConversationToastMessageSubState } from '../genesys-cloud-common-conversations.state';
import * as ToastMessageActions from '../actions/conversation-toast-message.actions';
import { conversationToastMessageAdapter } from '../adapters';

const toastMessageReducer = createReducer(
  initialConversationToastMessageSubState(),
  on(ToastMessageActions.openConversationToastMessage, (state, { toastMessage }): State => {
    const existingSubState = state[toastMessage.conversationId] ?? conversationToastMessageAdapter.getInitialState();
    return {
      ...state,
      [toastMessage.conversationId]: conversationToastMessageAdapter.upsertOne(toastMessage, existingSubState)
    };
  }),
  on(ToastMessageActions.closeConversationToastMessage, (state, { conversationId, toastMessageId }): State => {
    const existingSubState = state[conversationId] ?? conversationToastMessageAdapter.getInitialState();
    return {
      ...state,
      [conversationId]: conversationToastMessageAdapter.removeOne(toastMessageId, existingSubState)
    };
  }),
  on(ToastMessageActions.closeAllOtherConversationToastMessages, (state, { conversationId }): State => ({
    [conversationId]: state[conversationId]
  }))
);

export const genesysCloudCommonConversationReducer = combineReducers({
  toastMessages: toastMessageReducer
});
